// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Get list user GET /api/v1/user */
export async function userList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userListParams,
  options?: { [key: string]: any },
) {
  return request<API.UserListPayloadDto>('/api/v1/user', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create user POST /api/v1/user */
export async function userCreate(
  body: API.UserCreateRequestDto,
  options?: { [key: string]: any },
) {
  return request<API.User>('/api/v1/user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get user detail GET /api/v1/user/${param0} */
export async function userDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.User>(`/api/v1/user/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Update user PUT /api/v1/user/${param0} */
export async function userUpdate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userUpdateParams,
  body: API.UserUpdateRequestDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.User>(`/api/v1/user/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Delete user DELETE /api/v1/user/${param0} */
export async function userDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/user/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Reset user password PUT /api/v1/user/reset-password */
export async function userResetPassword(
  body: API.UserResetPasswordRequestDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/user/reset-password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Change user status PUT /api/v1/user/status */
export async function userChangeStatus(
  body: API.ChangeManyStatusParamDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/user/status', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
